import React from "react";
import { backgroundVideoUrl } from "src/constants/Data";

function Background() {
  return (
    <>
      <video
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        className="-z-10 pointer-events-none min-w-screen w-full h-full object-cover absolute inset-0 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <source src={backgroundVideoUrl} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-black opacity-25" />
    </>
  );
}

export default Background;
